import { BankingProductMovementsApiResponse } from '@repo/accounts-types'
import { ApiResponse, GenericOperationState } from '@repo/core'
import { RootState } from '../../../store/types'

export const bankingProductMovementsDataSelectorConfig = {
  bankingProductMovementsDataSelector: {
    getRootPath: function (
      state: RootState,
    ): GenericOperationState<ApiResponse<BankingProductMovementsApiResponse> | null> {
      return state.accounts.master.list.bankingProductMovements
    },
  },
}
